export const abridgementText = (text, number = 20) => {
  const sliceText =
    text.length >= number + 1 ? `${text.slice(0, number - 1)}…` : text;
  return sliceText;
};
